import React from "react";
import { arrayOf, node, shape, string } from "prop-types";
import Picture, { sourceItemPropTypes } from "../Picture";
import { classes } from "../utils/classes";
import UList from "../UList";
import OList from "../OList";
import Link from "../Link";
import BlockQuoteSimple from "../BlockQuoteSimple";
import Heading from "../Heading";
import Paragraph from "../Paragraph";
import Image from "../Image";
import ImageCaption from "../Image/Caption";

export const PostElementTitleH1 = ({ className = "", ...props }) => (
	<Heading Tag="h1" className={classes("post-element__title-h1", className)} {...props} />
);

PostElementTitleH1.propTypes = {
	...Heading.propTypes,
};

export const PostElementTitleH2 = ({ className = "", ...props }) => (
	<Heading Tag="h2" className={classes("post-element__title-h2", className)} {...props} />
);

PostElementTitleH2.propTypes = {
	...Heading.propTypes,
};

export const PostElementTitleH3 = ({ className = "", ...props }) => (
	<Heading Tag="h3" className={classes("post-element__title-h3", className)} {...props} />
);

PostElementTitleH3.propTypes = {
	...Heading.propTypes,
};

export const PostElementTitleH4 = ({ className = "", ...props }) => (
	<Heading Tag="h4" className={classes("post-element__title-h4", className)} {...props} />
);

PostElementTitleH4.propTypes = {
	...Heading.propTypes,
};

export const PostElementTitleH5 = ({ ...props }) => (
	<Heading Tag="h5" className="post-element__title-h5" {...props} />
);

export const PostElementTitleH6 = ({ ...props }) => (
	<Heading Tag="h6" className="post-element__title-h6" {...props} />
);

export const PostElementParagraph = ({ ...props }) => (
	<Paragraph className="post-element__paragraph" {...props} />
);

export const PostElementUl = ({ ...props }) => <UList className="post-element__ul" {...props} />;
export const PostElementListItem = ({ ...props }) => (
	<UList.Item className="post-element__list-item" {...props} />
);

export const PostElementOl = ({ ...props }) => <OList className="post-element__ol" {...props} />;

export const PostElementLink = ({ ...props }) => <Link isBaseClassName={false} {...props} />;

export const PostElementImage = ({
	className = "",
	src,
	srcList = [],
	alt = "",
	caption = "",
	...props
}) => {
	return (
		<ImageCaption isBlock className={classes("post-element__image", className)} caption={caption}>
			{srcList.length ? <Picture isBaseUrl={false} src={src} srcList={srcList} {...props} /> : null}
			{src && !srcList.length ? <Image isBaseUrl={false} src={src} alt={alt} {...props} /> : null}
		</ImageCaption>
	);
};

PostElementImage.propTypes = {
	src: Image.propTypes.src,
	srcList: arrayOf(shape(sourceItemPropTypes)),
	alt: Image.propTypes.alt,
	caption: ImageCaption.propTypes.caption,
	className: string,
};

export const PostElementVideo = ({ caption = "", children }) => {
	const captionText = caption.trim();
	return (
		<div className="post-element__video">
			{children}
			{captionText && <div className="post-element__video-caption">{captionText}</div>}
		</div>
	);
};

PostElementVideo.propTypes = {
	caption: string,
	children: node.isRequired,
};

export const PostElementLine = ({ className = "", ...props }) => (
	<div className={classes("post-element__line", className)} {...props} />
);

PostElementLine.propTypes = {
	className: string,
};

export const PostElementBlockQuote = ({ ...props }) => (
	<BlockQuoteSimple className="post-element__blockquote" {...props} />
);
